module.exports = __webpack_public_path__ + "static/media/user.f189b7b6.svg";